const KEY = "tenant_slug";
const SLUG = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;

export const getTenantSlug = () => localStorage.getItem(KEY);
export const setTenantSlug = (s) => (s && SLUG.test(s) ? localStorage.setItem(KEY, s) : localStorage.removeItem(KEY));

export function bootstrapTenant() {
  const q = new URLSearchParams(window.location.search).get("c");
  if (q) setTenantSlug(q.toLowerCase());
}

export const BLOCKED_STATES = ["bloqueado"];
